import { render, staticRenderFns } from "./specialCategoryProductManager.vue?vue&type=template&id=3ff940eb"
import script from "./specialCategoryProductManager.vue?vue&type=script&lang=js"
export * from "./specialCategoryProductManager.vue?vue&type=script&lang=js"
import style0 from "./specialCategoryProductManager.vue?vue&type=style&index=0&id=3ff940eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports